<template>
  <b-button 
    :key="doc.public_id" 
    :href="doc.secure_url"
    variant="dark"
    target="_blank"
    pill
  >
    <font-awesome-icon icon="paperclip" />
    {{ doc.original_filename }}.{{
      doc.format
    }} ({{ formatBytes(doc.bytes) }})
  </b-button>
</template>
<script>
export default {
    name: 'ResourceDownload',
    components: {},
    mixins: [],
    props: {
        doc: {
            type:Object,
            default: () => {}
        }
    },
    data() {
        return  {
        }
    },
    computed: {},
    watch: {},
    mounted () {
        
    },
    methods: {
        formatBytes(bytes, decimals = 2) {
            if (bytes === 0) return "0 Bytes";

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
        },
    },
          
}
</script>